import React from 'react';
import AutoCarousel from './AutoCarousel';
import Approach from './Approch';
import MyCard from './MyCard';
import InfoCard from './InfoCard';
import ProjectsComponent from './ProjectsComponent';
import ImageParallax from './ImageParallax';
import Testimonials from './Testimonials';
import Platfrom from './Platfrom';
import Stats from './Stats';


function Home() {
  return (
    <>
      <AutoCarousel></AutoCarousel>
      <Approach></Approach>
      <InfoCard></InfoCard>
      <br></br>
      <MyCard></MyCard>
      <ImageParallax></ImageParallax>
      <br></br>
      <Testimonials></Testimonials>
      <br></br>
     
      <br></br>
      <Stats></Stats>
      <br></br>
      <ProjectsComponent></ProjectsComponent>
      <br></br>

      
    </>
  );
}

export default Home;
